import styled from 'styled-components';
import { CloseButton } from '../../pages/RetailCreate/Styles';

export const GalleryContainer = styled.main`
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
`;

export const Gallery = styled.div`
  max-width: 1146px;
  max-height: 100vh;
  padding: 20px 0;
  margin: 0 auto;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;

  @media only screen and (max-width: ${({ theme }) => theme.BP.VDP_MOBILE_WH}) {
    justify-content: center;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_XLARGE}) {
    padding: 40px 0;
    max-width: ${({ isLightbox }) => (isLightbox ? '2160px' : '100vw')};
  }
`;

export const Close = styled(CloseButton)`
  position: static;
  align-self: flex-end;
  width: 88px;
  min-height: 30px;
  margin: 0 0 12px 0;
`;

Close.Icon = styled(CloseButton.Icon)``;
